export const RIDE_ID_FILTER_TEXT = {
	label: 'Search by Ride ID',
	placeholder: 'e.g. 364fb2b5-dbe0',
};

/**
 * Ride ID is a UUID — always exactly 36 characters.
 */
export const RIDE_ID_LENGTH = 36;
